module.exports = __webpack_public_path__ + "img/mail.5d379871.svg";